import React, {PropTypes} from 'react';
import DisplayIf from 'shared/DisplayIf.jsx';
import {formatCurrency} from 'shared/util/formatCurrency';
Number.prototype.formatCurrency = formatCurrency;

const PayBalance = ({
  balanceDue,
  onPayBalanceClick,
  onPurchaseClick,
  enabledWebHooks,
  onWebHooksClick,
  environment
}) => (
  <div>
    <div className="flex right">
      <DisplayIf condition={!!balanceDue}
        className="display inline">
        <button className="btn btn-primary btn-lg"
            type="button"
            onClick={onPayBalanceClick}>
            {`Pay $${balanceDue.formatCurrency(2)}`}
        </button>
      </DisplayIf>
      <div className="display inline">
        <button
          style={{minWidth: 150, marginLeft: 10}}
          className="btn btn-default btn-lg"
          type="button"
          onClick={() => onPurchaseClick()}>
            {'Register More'}
        </button>
      </div>
    </div>
    <br/>
    <div className="flex right">
      <DisplayIf condition={!!balanceDue && (environment != 'PROD' && environment != 'PRODUCTION')} 
        className="custom-checkbox-container" 
        style={{ float: "left", paddingBottom: 15 }}>
        <input type="checkbox"
          id="webHooks"
          checked={enabledWebHooks}
          onChange={event => onWebHooksClick(event.target.checked)}/>
        <label htmlFor="webHooks">
          Click here to process payments in real time.
        </label>
      </DisplayIf>
    </div>
  </div>
);

PayBalance.propTypes = {
  balanceDue: PropTypes.number,
  onPayBalanceClick: PropTypes.func,
  onPurchaseClick: PropTypes.func,
  onPrintClick: PropTypes.func,
  enabledWebHooks: PropTypes.bool,
  onWebHooksClick: PropTypes.func,
  environment: PropTypes.string
};

PayBalance.defaultProps = {
  balanceDue: 0
};

export default PayBalance;



// WEBPACK FOOTER //
// ./src/features/registration/manage/PayBalance.jsx